<ng-container *ngIf="list">
  <div class="mt-6 flex justify-end">
    <patternlib-textlink
      [label]="'button_reset' | translate"
      class="align-self-end"
      size="small"
      icon-position="left"
      (click)="this.onResetClicked()"
    >
      <patternlib-icon icon-name="filter-reset" size="24px" slot="icon">
      </patternlib-icon>
    </patternlib-textlink>
    <patternlib-textlink
      [label]="'filters' | translate"
      class="align-self-end ms-5"
      size="small"
      icon-position="left"
      (click)="this.onShowFilter()"
    >
      <patternlib-icon icon-name="filter-adjust" size="24px" slot="icon">
      </patternlib-icon>
    </patternlib-textlink>
  </div>
  <ng-container *ngIf="this.showFilter">
    <ng-container *ngIf="this.groups[0].options().length > 1">
      <span class="text-copy font-text-bold">{{ "category" | translate }}</span>

      <div class="mt-4 flex gap-2">
        <patternlib-pill
          *ngFor="let value of groups[0].options(); index as i"
          label="{{ value }}"
          [selected]="this.groups[0].selectedValues.includes(value)"
          (lhClick)="this.onPillClick($event)"
        ></patternlib-pill>
      </div>
    </ng-container>
    <div class="mt-5 flex basis-1/3 gap-6">
      <patternlib-multiselect
        *ngFor="let group of groups.slice(1, 3)"
        label="{{ group.fieldName | translate }}"
        size="small"
        filterable="true"
        [placeholderText]="'placeholder_filter_search' | translate"
        hideSelectAllButton="true"
        hideApply="false"
        [applyButtonText]="'apply_filter' | translate"
        [value]="group.selectedValues"
        (lhSelect)="this.onMultiselect(group.fieldName, $event)"
      >
        <patternlib-check-option
          *ngFor="let value of group.options(); index as i"
          [value]="value"
          [label]="value"
        >
        </patternlib-check-option>
      </patternlib-multiselect>
      <patternlib-multiselect
        *ngIf="this.groups[3].options().length > 1"
        label="{{ this.groups[3].fieldName | translate }}"
        size="small"
        filterable="true"
        [placeholderText]="'placeholder_filter_search' | translate"
        hideSelectAllButton="true"
        hideApply="false"
        [value]="this.groups[3].selectedValues"
        (lhSelect)="this.onMultiselect(this.groups[3].fieldName, $event)"
      >
        <patternlib-check-option
          *ngFor="let value of this.groups[3].options(); index as i"
          [value]="value"
          >{{ value }}</patternlib-check-option
        >
      </patternlib-multiselect>
    </div>
  </ng-container>
</ng-container>
